module.exports = __webpack_public_path__ + "img/l4.bfb57281.jpg";